import { DISPLAY_ACTION, DISPLAY_IDLE_ACTION } from 'src/features/actions/utils/types';
import { actionsMessages } from 'src/features/actions/utils/messages';

export const DISPLAY_ACTION_TYPE_MAP = {
    [DISPLAY_ACTION.SUCCESSFUL_ENTRANCE]: actionsMessages.successfulEntrance,
    [DISPLAY_ACTION.REJECTED_ENTRANCE]: actionsMessages.rejectedEntrance,
    [DISPLAY_ACTION.SUCCESSFUL_EXIT]: actionsMessages.successfulExit,
    [DISPLAY_ACTION.REJECTED_EXIT]: actionsMessages.rejectedExit,
    [DISPLAY_ACTION.EXIT_PAYMENT_DUE_AMOUNT]: actionsMessages.exitPaymentDueAmount,
    [DISPLAY_ACTION.EXIT_PAYMENT_INSERT_CARD]: actionsMessages.exitPaymentInsertCard,
    [DISPLAY_ACTION.EXIT_PAYMENT_CARD_ACCEPTED]: actionsMessages.exitPaymentCardAccepted,
    [DISPLAY_ACTION.EXIT_PAYMENT_CARD_REJECTED]: actionsMessages.exitPaymentCardRejected,
    [DISPLAY_ACTION.EXIT_PAYMENT_PIN_REQUESTED]: actionsMessages.exitPaymentPinRequested,
    [DISPLAY_ACTION.EXIT_PAYMENT_PROCESSING]: actionsMessages.exitPaymentProcessing,
    [DISPLAY_ACTION.EXIT_PAYMENT_CONFIRMED]: actionsMessages.exitPaymentConfirmed,
    [DISPLAY_ACTION.EXIT_PAYMENT_FAILED]: actionsMessages.exitPaymentFailed,
};

export const DISPLAY_IDLE_ACTION_TYPE_MAP = {
    [DISPLAY_IDLE_ACTION.DATE]: actionsMessages.date,
    [DISPLAY_IDLE_ACTION.SPACES]: actionsMessages.spaces,
    [DISPLAY_IDLE_ACTION.LPR]: actionsMessages.lpr,
    [DISPLAY_IDLE_ACTION.TICKET]: actionsMessages.ticket,
    [DISPLAY_IDLE_ACTION.CARD]: actionsMessages.card,
};
